module.exports = __webpack_public_path__ + "static/media/moisture.4d00683c.svg";